import React from "react";
import { Boxes } from "lucide-react";

const PRODUCTS = [
  "SmartContainer™", "CommodityBid™", "RFQ™",
  "FullContainer™", "Verified Manufacturers™", "BulkContainer™",
];

export default function Footer() {
  return (
    <footer className="border-t border-slate-200 bg-white">
      <div className="mx-auto max-w-7xl px-6 py-14 lg:px-8">
        <div className="flex flex-col justify-between gap-10 lg:flex-row">
          <div className="max-w-sm">
            <div className="flex items-center gap-2.5">
              <span className="flex h-8 w-8 items-center justify-center rounded-lg bg-[#0052FF] text-white">
                <Boxes className="h-[18px] w-[18px]" />
              </span>
              <span className="font-display text-[15px] font-bold text-[#0A1128]">
                BulkContainer<sup className="ml-0.5 text-[9px] text-[#94A3B8]">™</sup>
              </span>
            </div>
            <p className="mt-4 text-[14px] leading-relaxed text-[#64748B]">
              A Workspace Product by DeMaxtore. Factory-direct bulk procurement from verified
              Turkish manufacturers — coordinated inside one connected Workspace.
            </p>
          </div>

          <div className="grid grid-cols-2 gap-10 sm:grid-cols-2">
            <div>
              <p className="font-mono-ui text-[11px] font-semibold uppercase tracking-widest text-[#94A3B8]">
                Workspace Products
              </p>
              <ul className="mt-4 space-y-2.5">
                {PRODUCTS.map((p) => (
                  <li key={p}>
                    <span className="text-[14px] font-medium text-[#475569] transition-colors hover:text-[#0A1128]">
                      {p}
                    </span>
                  </li>
                ))}
              </ul>
            </div>
            <div>
              <p className="font-mono-ui text-[11px] font-semibold uppercase tracking-widest text-[#94A3B8]">
                Platform
              </p>
              <ul className="mt-4 space-y-2.5">
                {["About DeMaxtore", "How it Works", "Verified Manufacturers", "Contact"].map((p) => (
                  <li key={p}>
                    <span className="text-[14px] font-medium text-[#475569] transition-colors hover:text-[#0A1128]">
                      {p}
                    </span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>

        <div className="mt-12 flex flex-col items-start justify-between gap-3 border-t border-slate-100 pt-6 sm:flex-row sm:items-center">
          <p className="text-[13px] text-[#94A3B8]">© {new Date().getFullYear()} DeMaxtore. All rights reserved.</p>
          <p className="text-[13px] text-[#94A3B8]">
            DeMaxtore coordinates procurement — it does not buy or sell products.
          </p>
        </div>
      </div>
    </footer>
  );
}
